import React, { lazy, Suspense, useEffect } from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Loader from '../common/components/loader';
import { createBrowserHistory } from 'history';
import PrivateRoute from './private-route';
import ErrorBoundary from 'common/components/errorBoundary';
import Modal from 'common/components/Modal';
import { pageViews } from 'common/utils/googleAnalytics';
import AttributesProvider from 'context/propertyAttributes';

const PropertyContainer = lazy(() => import('pages/property'));

const DashboardContainer = lazy(() => import('pages/dashboard'));

const AugmentationContainer = lazy(() => import('pages/augmentation'));

const LoginContainer = lazy(() => import('pages/login'));

const DemandPartnerContainer = lazy(() => import('pages/demandPartners'));

const TermsConditionsContainer = lazy(() =>
  import('pages/terms-and-conditions')
);

const ProductInformationContainer = lazy(() =>
  import('pages/product-informations')
);

const PageNotFound = lazy(() => import('common/components/page-not-found'));

export const history = createBrowserHistory();

// A wrapper to apply AttributesProvider only where needed
const WithAttributes = ({ children }) => (
  <AttributesProvider>{children}</AttributesProvider>
);

const AppRoute = () => {
  useEffect(() => {
    const unlisten = history.listen(() => {
      pageViews();
    });

    return () => unlisten();
  }, []);

  return (
    <Router history={history}>
      <ToastContainer />
      <Modal />
      <Suspense fallback={<Loader />}>
        <ErrorBoundary>
          <Switch>
            <Route exact path="/login" component={LoginContainer} />

            <Route exact path="/access" component={LoginContainer} />

            <Route
              exact
              path="/terms-conditions"
              component={TermsConditionsContainer}
            />

            {/* <Route exact path="/" component={ProductInformationContainer} /> */}
            <Route exact path="/" component={LoginContainer} />
            <PrivateRoute
              path="/property-details/:brand/:pid/en"
              component={(props) => (
                <WithAttributes>
                  <PropertyContainer {...props} />
                </WithAttributes>
              )}
            />
            <PrivateRoute
              exact
              path="/dashboard"
              component={() => (
                <WithAttributes>
                  <DashboardContainer />
                </WithAttributes>
              )}
              />
              
            <PrivateRoute
              exact
              path="/augmentation/:brand/:pid"
              component={AugmentationContainer}
            />

            {/* <PrivateRoute
              path="/create-property"
              component={PropertyContainer}
            /> */}

            <PrivateRoute
              exact={true}
              path="/demand-partners"
              component={DemandPartnerContainer}
            />

            <Route component={PageNotFound} />
          </Switch>
        </ErrorBoundary>
      </Suspense>
    </Router>
  );
};

export default AppRoute;
